import React, {useEffect, useState} from "react";
import Map from "./components/Map";
import 'bootstrap/dist/css/bootstrap.min.css';
import {Spinner} from "react-bootstrap";
import Loading from "./loading";



const Main = () => {
    const [locations, setLocations] = useState(null);
    const [loading, setLoading] = useState(false);

    function getData() {
        console.log("in getData")
        setLoading(true)
        fetch('https://us-central1-aircourt-d62eb.cloudfunctions.net/widgets/all', {
            method: 'GET',
        })
            .then((response) => response.json())
            .then((data) => {
                console.log("got data")

                return (data);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }


    useEffect(() => {
        //setLocations(getData())
        setLoading(true)
    }, []);



        return (
            <div>
                <Loading show={loading} />
                <Map
                    setLoading={setLoading}
                />
            </div>
        );



};

export default Main;
